import { useState, useEffect, useCallback } from "react"
import "./index.css"
import { requestNotificationPermission } from "../../../firebase/messaging.js"
import { toast } from "react-toastify"

const UserAgent = () => {

    const UAParser = require('ua-parser-js')
    const info = JSON.stringify(new UAParser().setUA(navigator.userAgent).getResult(), null, 2)

    var [token, setToken] = useState()

    const testNotif = () => {
        // Function to schedule local notification
        function scheduleLocalNotification(title, options, delay) {
            if ('serviceWorker' in navigator && 'Notification' in window) {
                navigator.serviceWorker.ready.then(registration => {
                    registration.active.postMessage({
                        type: 'scheduleNotification',
                        title: title,
                        options: options,
                        delay: delay
                    });
                }).catch(error => {
                    console.error('Error posting message to service worker:', error);
                });
            } else {
                console.error('Service worker or Notification API not supported');
            }
        }

        // Example usage
        scheduleLocalNotification('Reminder', {
            body: 'Test notif!',
            badge: '/favicon.png',
            image: '/favicon.png',
            icon: '/favicon.png',
            data: { test: "ok" },
            actions: [
                {
                    action: 'view',
                    title: 'View',
                    icon: '/view-icon.png'
                },
                {
                    action: 'dismiss',
                    title: 'Dismiss',
                    icon: '/dismiss-icon.png'
                },
            ],
        }, 10)
    }

    useEffect(() => {
        requestNotificationPermission()
            .then(setToken)
            .catch((err) => {
                console.error("Permission denied:", err)
            })
    }, [])

    const copyText = useCallback(() => {
        navigator.clipboard.writeText(token).then(() => {
            toast.info("Token copied to clipboard!")
        }).catch(toast.error)
    }, [token])

    return (
        <>
            <div onClick={testNotif} style={{ margin: "2vw", backgroundColor: "blue", color: "white", padding: "2vw", textAlign: "center", cursor: "pointer" }}>Test Notification</div>
            <div className="user-agent-root">{info}</div>

            <div>
                <div style={{ margin: "2vw", maxWidth: "80vw", overflow: "scroll" }}>{token}</div>
                <div onClick={copyText} style={{ margin: "2vw", backgroundColor: "blue", color: "white", padding: "2vw", textAlign: "center", cursor: "pointer" }}>Copy Token</div>
            </div>
        </>
    )
}

export default UserAgent